export enum CoverageUuid {
  // #1 - Network Security & Privacy Liability
  NetworkSecurityPrivacyLiability = '4ecb1358-f82f-4f1e-890c-f7bc8f14f739',
  // #2 - Regulatory Proceedings
  RegulatoryProceedings = '0478ce64-8a5e-487b-ac0c-493290750fbb',
  // #3 - PCI-DSS Events
  PciDssEvents = '529c1f9c-3aae-45c2-b95e-5e8366f830f8',
  // #4 - Incident Response
  IncidentResponse = '0831b749-acfb-497c-a8f2-0fa923bf2dc8',
  // #5 - Cyber Extortion
  CyberExtortion = 'bd2afc71-6a4c-4e03-a977-bc6202ecdfbb',
  // #6 - Digital Asset Recovery
  DigitalAssetRecovery = '3c21dae0-2d6c-4e6d-829f-8b0ee6992a83',
  // #7 - Bricked Equipment Replacement
  BrickedEquipmentReplacement = '3fb62f52-6d82-40d8-8b08-c95c62e71cdd',
  // #8 - Cyber Crime
  CyberCrime = '5e30a5d2-a741-479c-bf59-98e2f2618b2f',
  // #9 - Business Interruption
  BusinessInterruption = '4be00fe4-45d5-4a53-b195-5d8c98b7a665',
  // #10 - Contingent Business Interruption
  ContingentBusinessInterruption = 'ec4d42c5-54bd-44e0-8d46-d170371ae636',
  // #11 - Reputational Harm
  ReputationalHarm = '148ccffd-5380-4f97-8b51-5463f21aa2b8',
}

export enum SubCoverageUuid {
  // #4 - Incident Response: #1 - Post Incident Remediation
  IncidentResponsePostIncidentRemediation = '5c342728-fba9-458b-ac23-456e10849d35',
  // #4 - Incident Response: #2 - Pre Claim Mitigation
  IncidentResponsePreClaimMitigation = '237a808a-a0e0-4095-8a5e-541ada7262b3',
  // #5 - Cyber Extortion: #1 - Criminal Reward
  CyberExtortionCriminalReward = '8f7b41a0-1d28-4c9a-921a-3e932f9ba5a5',
  // #8 - Cyber Crime: #1 - Social Engineering
  CyberCrimeSocialEngineering = 'f86e2f2a-547f-4cd3-86fa-af5de2ddfbdd',
  // #8 - Cyber Crime: #2 - Telecom Fraud
  CyberCrimeTelecomFraud = '01505a46-5136-4579-aed4-b73f1929bba2',
  // #8 - Cyber Crime: #3 - Invoice Manipulation
  CyberCrimeInvoiceManipulation = '85d3bd90-2299-46a9-a1ad-4b04fdd44e6b',
  // #8 - Cyber Crime: #4 - Cryptojacking
  CyberCrimeCryptojacking = '540a7692-afb7-4b1e-bf0e-2d2e568dd680',
  // #8 - Cyber Crime: #5 - Computer Fraud
  CyberCrimeComputerFraud = '3afa23ac-233c-4b82-834d-43eb6f1966ca',
  // #8 - Cyber Crime: #6 - Funds Transfer Fraud
  CyberCrimeFundsTransferFraud = '694211e3-a6a1-4e24-af5b-7c428b6129f5',
  // #9 - Business Interruption: #1 - Proof of Loss
  BusinessInterruptionProofOfLoss = 'ae9e380b-946d-4514-a7f7-ae3e378f5d49',
  // #10 - Contingent Business Interruption: #1 - Proof of Loss
  ContingentBusinessInterruptionProofOfLoss = 'ae9e380b-946d-4514-a7f7-ae3e378f5d49',
  // #11 - Reputational Harm: #1 - Proof of Loss
  ReputationalHarmProofOfLoss = 'ae9e380b-946d-4514-a7f7-ae3e378f5d49',
  // TODO: Reconcile these manually added ones with the API:
  NonItProviders = 'e1863fe0-c0a0-4923-a5a1-3be8662e15c7',
  ProofOfLoss = 'ae9e380b-946d-4514-a7f7-ae3e378f5d49',
  CriminalReward = '8f7b41a0-1d28-4c9a-921a-3e932f9ba5a5',
}

export enum EndorsementUuid {
  // #1 - Automatic Extended Reporting Amendatory
  AutomaticExtendedReportingAmendatory = '4af9b58a-4206-423c-8167-2d50b9c6cbb5',
  // #2 - Cancellation Endorsement
  CancellationEndorsement = '9a7c39a6-09d4-4c59-bfa0-383bc39daa74',
  CancellationEndorsementForExcess = '8164e660-4b96-4f3a-890f-3c29dc545850',
  Cancellation = CancellationEndorsement,
  // #3 - Cancellation For Nonpayment of Premium Only
  CancellationForNonpaymentOfPremiumOnly = '4d04e01f-35ca-41bd-a5f3-dbeae3b09a7b',
  // #4 - Cancellation and Nonrenewal Endorsement
  CancellationAndNonrenewalEndorsement = '51d3e608-d5f9-4e09-9522-81c19d2266c5',
  CancellationAndNonrenewal = CancellationAndNonrenewalEndorsement,
  // #5 - Consent to Settle Endorsement
  ConsentToSettleEndorsement = '6067ea2c-14da-44ba-9bde-7f3204ebf656',
  ConsentToSettle = ConsentToSettleEndorsement,
  // #6 - Contingent Bodily Injury and Property Damage Endorsement
  ContingentBodilyInjuryAndPropertyDamageEndorsement = '5f6b574c-148c-433b-9824-f881fab2e532',
  ContingentBodilyInjuryAndPropertyDamage = ContingentBodilyInjuryAndPropertyDamageEndorsement,
  // #7 - Contingent Business Interruption - Non-IT Providers
  ContingentBusinessInterruptionNonItProviders = 'a37ecf46-441a-462f-b299-df4d4e1a50ec',
  // #8 - Control Group Amendatory
  ControlGroupAmendatory = '04e483ba-dd5c-4859-96d9-b60085e07c7b',
  // #9 - Media Event Liability Endorsement
  MediaEventLiabilityEndorsement = '9041f69f-f216-4ffa-9f44-7488905eaae4',
  MediaEventLiability = MediaEventLiabilityEndorsement,
  // we will back to this one
  MediaEventLiabilityOnlineOfflineEndorsement = MediaEventLiabilityEndorsement,
  // #10 - Newly Acquired Entity Endorsement
  NewlyAcquiredEntityEndorsement = '7ee33742-8455-4872-b9b3-6b430d943463',
  NewlyAcquiredEntity = NewlyAcquiredEntityEndorsement,
  // #11 - Notice of Terrorism Insurance Coverage
  // NoticeOfTerrorismInsuranceCoverage = '39225ef0-2f04-483c-87dc-89a69bdcb3fd',
  // #12 - Operational Technology - Bricked Equipment
  OperationalTechnologyBrickedEquipment = '7db773c0-8813-4261-bae2-77e97e397ffb',
  // #13 - Operational Technology - Digital Assets
  OperationalTechnologyDigitalAssets = '1f58b178-ee59-4825-b211-d74a5d1676e1',
  // #14 - Policy Reinstatement Endorsement
  PolicyReinstatementEndorsement = 'f26a4104-d182-4f1e-b565-f27f5afb5368',
  PolicyReinstatement = PolicyReinstatementEndorsement,
  // #15 - Retroactive Date Amendatory
  RetroactiveDateAmendatory = 'd3740e31-2510-40c4-8037-d6e7d657afa8',
  // #16 - Schedule of Additional Insured
  ScheduleOfAdditionalInsured = 'e9b44603-fcab-4a80-8748-45749d55d0a2',
  // #17 - Schedule of Named Insured
  ScheduleOfNamedInsured = '0df24881-d3b0-4a47-aba3-9e917f34c74c',
  // #18 - Service of Process Endorsement
  ServiceOfProcessEndorsement = 'daf4bf8a-6b2c-49c2-9685-365e2e7f03ba',
  ServiceOfProcess = ServiceOfProcessEndorsement,
  // #19 - State Fraud Statement
  StateFraudStatement = '35f2894d-afc1-48b1-a0b5-8c894c1c9e10',
  // #20 - Technology Errors and Omissions Endorsement
  TechnologyErrorsAndOmissionsEndorsement = 'c47d87bd-e452-4a58-bd4a-87fdf6397f48',
  TechnologyErrorsAndOmissions = TechnologyErrorsAndOmissionsEndorsement,
  // #21 - Waiver of Change in Control Endorsement
  WaiverOfChangeInControlEndorsement = 'c876b210-a9d9-4f57-8e39-1c8b4dac909d',
  WaiverOfChangeInControl = WaiverOfChangeInControlEndorsement,
  // #22 - Wrongful Collection Exclusion Endorsement
  WrongfulCollectionExclusionEndorsement = '280b0546-585b-4cf4-9a95-031543195d69',
  WrongfulCollectionExclusion = WrongfulCollectionExclusionEndorsement,
  // #23 - Wrongful Collection Exclusion Pixel Endorsement
  WrongfulCollectionExclusionPixelEndorsement = '87268c68-e3b3-474d-90e0-3148645dd45c',
  // #100 - Policyholder Notice
  // PolicyholderNotice = 'a381fe95-f69f-4d7e-bdca-e6594a41e4d6',
  // #101 - Follow Form of Underlying Provisions Endorsement (Follow Specified Insuring Agreements – Recognize Erosion)
  FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsRecognizeErosionForExcess = '308b01e8-04e2-4118-a555-acd92c06ee9a',
  FollowFormOfUnderlyingProvisionsFollowSpecifiedInsuringAgreementsRecognizeErosionForExcess = FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsRecognizeErosionForExcess,
  FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsReco = FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsRecognizeErosionForExcess,
  // #102 - Follow Form of Underlying Provisions Endorsement (Follow Specified Insuring Agreements – Not Recognize Erosion)
  FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsNotRecognizeErosionForExcess = '91281677-8f5d-47a3-b154-0573f6795db8',
  FollowFormOfUnderlyingProvisionsFollowSpecifiedInsuringAgreementsNotRecognizeErosionForExcess = FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsNotRecognizeErosionForExcess,
  FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsNotR = FollowFormOfUnderlyingProvisionsEndorsementFollowSpecifiedInsuringAgreementsNotRecognizeErosionForExcess,
  // #103 - Infrastructure Exclusion
  InfrastructureExclusionForExcess = 'cf666b01-6bf9-492c-ab75-9210daa4eb91',
  // #104 - Natural Perils Exclusion
  NaturalPerilsExclusionForExcess = '738305cf-ee8c-4ea8-880a-424ce8101e1b',
  // #105 - Not Following Underlying Insurance (Not Recognize Erosion)
  NotFollowingUnderlyingInsuranceNotRecognizeErosionForExcess = 'c0e7aa5c-a57f-4cd8-bf7b-181ef2194c6d',
  // #106 - Not Following Underlying Insurance (but Recognize Erosion)
  NotFollowingUnderlyingInsuranceButRecognizeErosionForExcess = 'cc872ae9-cb43-4115-8d82-2dde85915dee',
  // #107 - U.S. Treasury Department’s Office of Foreign Assets Control (OFAC)
  USTreasuryDepartmentsOfficeOfForeignAssetsControlOfacForExcess = '29eaefab-f6c1-4fad-a5f9-43ead1b383b2',
  // #108 - Pending and Prior Litigation Exclusion for Higher Limits
  PendingAndPriorLitigationExclusionForHigherLimitsForExcess = '48fab8ea-9d8b-4732-868c-17ccb89e5a7c',
  // #109 - Pending and Prior Litigation Exclusion
  PendingAndPriorLitigationExclusionForExcess = 'dea6b467-5e04-4037-91cc-9489c1f1e287',
  // #110 - Prior Knowledge Exclusion
  PriorKnowledgeExclusionForExcess = '738ae565-ca45-48ca-a036-77acbaacd91f',
  // #111 - Retroactive Date Endorsement
  RetroactiveDateEndorsementForExcess = 'eef49489-ec20-4ff7-9b88-147b626b1c95',
  RetroactiveDateForExcess = RetroactiveDateEndorsementForExcess,
  // #112 - Retroactive Date Amendatory for Increased Limits
  RetroactiveDateAmendatoryForIncreasedLimitsForExcess = 'b592e4fe-ec17-4600-8565-7a278bb4d346',
  // #113 - Sublimited Coverage Endorsement
  SublimitedCoverageEndorsementForExcess = '390c8c82-ae49-43b9-9bc7-abcefc9e8c5e',
  SublimitedCoverageForExcess = SublimitedCoverageEndorsementForExcess,
  // #114 - War Exclusion
  WarExclusionForExcess = '6e0cb132-e118-43a2-b12a-b812bbcb8813',
  // #115 - War Exclusion with Cyberterrorism Carveback
  WarExclusionWithCyberterrorismCarvebackForExcess = 'a5df5c5b-51a1-430f-8bee-d5e7492a844f',
  // #116 - Declarations Amendatory Endorsement
  DeclarationsAmendatoryEndorsementForExcess = '59a46941-6d2e-47e0-806c-54881bd4ba2d',
  DeclarationsAmendatoryForExcess = DeclarationsAmendatoryEndorsementForExcess,
  // #117 - Additional Privacy Event Expenses Outside the Limit
  AdditionalPrivacyEventExpensesOutSideLimit = 'f04c31b5-2e41-4405-9574-6b6dad06194c',
  // #118 Lockton Affinity Amendatory
  LocktonAffinityAmendatory = '654b788f-e126-4ebd-bb5f-baa9167da513',
  // #119 Cyber Crime Loss Definition Amendatory
  CyberCrimeDefinitionOfLossAmendatory = '37ee1b21-8cf3-407d-ba63-01590bd0eea2',
  // // #120
  // MediaEventLiabilityOnlineOfflineEndorsement = 'f1ac94c5-1f03-47c7-b5ba-6c8c9f0a0bc8',
  // #121 RT RT Amendatory Endorsement
  RTAmendatoryEndorsement = 'b1249d0c-d67e-4979-963a-2d9220688d34',
  // #122 Quotashare Endorsement
  QuotaShareEndorsement = 'c14927ed-14d1-4516-8cf4-bb26a8fd44a0',
  QuotaShareExcessEndorsement = '5d8f4b2e-176e-4b4d-8a3b-c580f33b517d',
  // #123 Technology Errors and Omissions Endorsement - Artificial Intelligence
  ArtificialIntelligenceEndorsement = '5dab990e-88cb-4fd2-9f67-dec500b509a7',
  // #124  Cyber and Technology Errors and Omissions
  CyberAndTechnologyErrorsAndOmissions = '3396e54c-e309-49a3-8549-23e4ad1986ca',
  // #125  BIPA claims expenses sublimit
  BipaClaimsExpensesSublimit = '9e90d1ea-7a58-4920-ac35-985b3b74ba86',
  // #126  TCPA Claims Expenses Sublimit of Insurance
  TcpaClaimsExpensesSublimit = '47f0977c-4b7e-4dbd-a6da-de47a28bfb02',
  TrackingTechnologyClaimsExpenseSublimit = 'e3c22b00-cee5-4870-a126-c8b801735896',
  //127 ADA Claims Expenses Sublimit
  AdaClaimsExpensesSublimit = '88738e9e-af74-4e71-9cc4-27abf62c8cba',
  //128 Service Of Suit Obsidian Clause of Washington
  ServiceOfSuitObsidianClauseWashington = 'aae47e45-aaa3-4872-b7c7-4448d128791d',
  //  129 Service Of Suit Obsidian
  ServiceOfSuitObsidian = 'c2988172-a02f-43e3-9495-238ad0dc1523',
  //  130 Service Of Suit Obsidian Clause of Illinois
  ServiceOfSuitObsidianClauseIllinois = 'efb3590e-2beb-4e2f-b1eb-a947ef2260d3',
  //131 Cryptojacking Limits Amendatory
  CryptojackingLimitsAmendatory = '2be9cf00-8687-4476-838f-83734e397437',
  //132 Cyber Enhancement Endorsement
  CyberEnhancementEndorsement = '42a4b72b-9c37-4bc1-8b36-69fdac80fbef',

  //133 Limit Amendatory Endorsement
  LimitAmendatoryEndorsement = '2f08ad7d-bccf-4b98-8c63-57c48af1c156',
  // 134  Service Of Suit Obsidian for Excess
  ServiceOfSuitObsidianForExcess = '7daa69f5-e78d-4cb8-ad41-c8e30bffe658',
  // 135  Service Of Suit Obsidian Clause of Illinois for Excess
  ServiceOfSuitObsidianClauseIllinoisForExcess = 'c705b762-f5a5-4a48-9be0-7c16d943f5d9',
  // 136  Service Of Suit Obsidian Clause of Washington for Excess
  ServiceOfSuitObsidianClauseWashingtonForExcess = 'c16a40b2-2823-48bd-aac9-096be5351f49',
  // 137 Service Of Suit Obsidian Clause of Colorado New Mexico Nevada
  ServiceOfSuitObsidianColoradoNewMexicoNevada = 'e8bfd009-1175-4785-9669-203b782022da',
  // 138 Service Of Suit Obsidian Clause of Colorado New Mexico Nevada for Excess
  ServiceOfSuitObsidianColoradoNewMexicoNevadaExcess = 'b31fa47f-ac8e-4beb-9ef8-bd926f453ef8',
  // 139 Service Of Suit Obsidian Florida for Excess
  ServiceOfSuitObsidianFloridaExcess = '86df5be2-e6e1-4ac3-a92d-48a2fb5bd3b9',
  // 134 Service Of Suit Obsidian Florida
  ServiceOfSuitObsidianFlorida = 'd3b9d8e5-71cb-4dd2-8899-68228cebd114',
  // 135 Service Of Suit Obsidian Kentucky for Excess
  ServiceOfSuitObsidianKentuckyExcess = 'eb429cc2-de65-487f-9bec-5a94ea3d169d',
  // 136 Service Of Suit Obsidian Kentucky
  ServiceOfSuitObsidianKentucky = '1a0f657e-623c-405a-ad82-1a0cebf70e68',
  // 137 Service Of Suit Obsidian Louisiana for Excess
  ServiceOfSuitObsidianLouisianaExcess = '8846c260-557e-4005-946a-bc930682903d',
  // 138  Service Of Suit Obsidian Louisiana
  ServiceOfSuitObsidianLouisiana = '07a8b2d1-f1ba-4f9d-b4fe-589cec2c72aa',
  // 139  Service Of Suit Obsidian Texas
  ServiceOfSuitTexas = '2346560b-faa1-4f64-b3b4-836017077198',
  // 140 Service Of Suit Obsidian Texas for Excess
  ServiceOfSuitTexasExcess = 'f7e031dc-15a9-4027-a746-e38072983a30',
  // 142 Service Of Suit Obsidian Virginia for Excess
  ServiceOfSuitVirginiaExcess = 'a3260860-0346-4e36-875d-522ee1e45bd7',
  // 143 Service Of Suit Obsidian Virginia
  ServiceOfSuitVirginia = '9a7a0136-4823-4114-93e0-2d75747f3cdd',
  // 144 Service Of Suit Obsidian Vermont for Excess
  ServiceOfSuitVermontExcess = 'e8435876-33e3-4dad-afe0-2a43c4f548be',
  // 145 Service Of Suit Obsidian Vermont
  ServiceOfSuitVermont = '14d31f01-67df-47ff-9951-c2980e0fedce',
  // 146 TRIA Cap On Losses From Certified Acts of Terrorism
  TRIACapOnLossesFromCertifiedActsOfTerrorism = 'a14d9a09-f057-4776-8b9f-c09c91603ba1',
  // 147 TRIA Excess Cap On Losses From Certified Acts of Terrorism
  TRIAExcessCapOnLossesFromCertifiedActsOfTerrorism = 'b88310e5-939b-490d-b857-fe6a7c4eb383',
  //148  RT Amendatory Endorsement -- Technology Errors & Omissions
  RTAmendatoryEndorsementTechnologyErrorsAndOmissions = '966894f9-e4de-48e6-b9a0-dd18244367bb',
  //149  Cyber Crime Event Definition Amendatory - Specified Property
  CyberCrimeEventDefinitionAmendatorySpecifiedProperty = 'ee9456c2-96f5-48b5-abf1-4b9160931bc9',
  // 150 Amwins Broker Amendatory
  AmwinsBrokerAmendatory = '5e453350-c2d3-48ba-a739-dd2035dd8bfc',
  //151 Bridge Specialty Cyber Enhancement Endorsement
  BridgeSpecialtyCyberEnhancementEndorsement = 'c46e502f-34c2-48c6-9664-63677930bab4',
  // 152 Other Insurance Amendatory Where Required by Contract
  OtherInsuranceAmendatory1058 = '08a1e285-e968-4102-86d8-42022c39c960',
  // 153 Ransomware Event Sublimit
  RansomwareEventSublimit = '2e832339-e5d9-4c8f-89e7-749b9dd95698',
  // 154 Cyber Extortion Amendatory
  CyberExtortionAmendatory = 'f464a712-8f23-4bf4-bf98-2b869f709feb',
  // 147 Cyber Event Amendatory
  CyberEventAmendatory = '7a7ff0a8-fa63-406f-83a6-1efc933b95af',
  // 155 Pre-Approved Authorized Provider
  PreApprovedAuthorizedProvider = '94e5ef3b-f41f-426c-8c7c-d50632509186',
  // 156 Other Insurance Amendatory
  OtherInsuranceAmendatory1053 = '452e8aa4-642a-4df4-adea-7630354f89b2',
  // 183 Missed Bid Amendatory
  MissedBidAmendatory = '2b29357e-fb23-4592-9f40-17ec524d363a',
  // Burns And Wilcox Cyber Enhancement Amendatory
  BurnsAndWilcoxCyberEnhancementAmendatory = 'fc4f396e-32e3-4bfa-9038-b6743540008a',

  // 158 War Exclusion Amendatory
  WarExclusionAmendatory = '25d1dfbd-4f3c-42e9-b44a-8d9732ae9599',
  // 159 Service of Suit Clause for Lloyd’s America, Inc
  LloydsAmericaServiceOfSuitClause = 'cb0828d2-0d4a-4ce3-9e87-e65bb67846dc',
  // 160  Technology Errors And Omissions Endorsement (NA)
  TechnologyErrorsAndOmissionsEndorsementNA = '5d758501-79b4-41dd-9683-9a9d7c9a9998',

  // 161 CRC Cyber Enhancement Endorsement
  CrcCyberEnhancement = 'c930fdf1-5c0f-4486-ba74-aee6936eeacd',
  // 162 Specific Event Exclusion - CCE 1049 (Primary)
  SpecificEventExclusion = '12774e48-608e-49eb-9a9f-915e86bb76f5',
  // 162a Specific Event Exclusion - Not Recognize Erosion - CCXS 1025 (Excess)
  SpecificEventExclusionNotRecognizeErosion = '95869e03-4809-452a-b7b4-5e2a5be54a00',
  // 162b Specific Event Exclusion - Recognize Erosion - CCXS 1026 (Excess)
  SpecificEventExclusionRecognizeErosion = 'f6333ae0-d857-44e5-b2f0-fa256c217bde',
  // 163 RPS Cyber Enhancement Endorsement - CCE 1103
  RPSCyberEnhancement = '856dd562-f469-4704-89b2-71c780b44721',
  // 164 Nuclear Energy Exclusion - CCXS 1018 (Excess)
  NuclearEnergyExclusion = 'c279b998-aec0-455b-bad3-2b68990e7a08',
  // 165 Nuclear Energy Or Contamination Endorsement - CCXS 1054 (Excess)
  NuclearEnergyOrContamination = '22549e3d-0b24-433c-8fcb-39dffde37dad',
  // 168 Trade Or Economic Sanctions Endorsement - CCXS 1053 (Excess)
  TradeOrEconomicSanctionsEndorsement = '069e3f9a-5abe-4cc1-9fbf-9a171dd0f8ba',
  // 166 Terrorism Risk Insurance Act Rejection Confirmation Endorsement
  TerrorismRiskInsuranceActRejectionConfirmationEndorsement = 'b1823436-2db9-4336-b921-edfb49651652',
  // 167 Tracking Technology Liability Coverage Endorsement
  TrackingTechnologyLiabilityCoverageEndorsement = 'b757e37b-3e96-48fe-b7fc-83874cca64e7',
  // Avoca Risk Cyber Enhancement Endorsement - CCE 1101
  AvocaRiskCyberEnhancement = '22209566-3086-4018-97ac-ad22fe801c57',
  // 160 Wholesure Amendatory Endorsement - CCE 1130
  WholeSureAmendatory = '743eddcc-fe8a-439d-b7ce-bc8d111a39e9',
  // 184 Contingent Business Interruption for Non-IT Amendatory (Franchised Risk)
  ContingentBusinessInterruptionNonItFranchisedRisk = '06bd03ed-87d4-4a30-afba-8e5edc45019f',
}

export enum SubjectivityUuid {
  // #1 - Completed & currently signed and dated applications
  CompletedCurrentlySignedAndDatedApplications = 'af8e2ca9-51d6-43fc-8545-77b082550de1',
  // #2 - Completed & currently signed and dated supplemental applications
  CompletedCurrentlySignedAndDatedSupplementalApplications = '5e83345a-8169-4bb7-80fe-ae0db148729f',
  // #3 - Completed, signed and dated Converge Application
  CompletedSignedAndDatedConvergeApplication = '4c465fd5-64ee-4be6-a7a8-fa9c7eb0956a',
  // #4 - Loss Runs (3 to 5 years)
  LossRuns3To5Years = '42365e60-4331-461e-a458-e86fd3210856',
  // #5 - Details on all paid and/or open claims
  DetailsOnAllPaidAndOrOpenClaims = 'ccb305b3-97e4-4566-88ee-4d83f06cc780',
  // #6 - Current Financial Information
  CurrentFinancialInformation = 'c7b34638-ad33-47d8-9bbb-f6fa81eff88b',
  // #7 - Currently signed and dated warranty statement
  CurrentlySignedAndDatedWarrantyStatement = 'c72d2d77-4aa5-436e-9265-e6d6308b4afb',
  // #8 - Currently signed and dated warranty statement for increased limits
  CurrentlySignedAndDatedWarrantyStatementForIncreasedLimits = '54096ee4-9260-4dbd-880a-c421ce7eb664',
  // #9 - Copy of the applicants organizational chart
  CopyOfTheApplicantsOrganizationalChart = 'a765fa91-8d80-4dd7-a920-3b1deed2dd9c',
  // #10 - Explanation of applications relationship with affiliate entities or sister companies
  ExplanationOfApplicationsRelationshipWithAffiliateEntitiesOrSisterCompanies = '5dbef317-9842-4193-99ed-81ea4e27b83c',
  // #11 - Copy of all underlying policies
  CopyOfAllUnderlyingPolicies = '522ba9cc-c71b-46f2-969c-7c1b90d04dc1',
  // #12 - Copy of all underlying quote letters
  CopyOfAllUnderlyingQuoteLetters = 'bfb4548b-59a4-43a4-b5a9-68fefca7940d',
  // #13 - Copy of all underlying binder letters
  CopyOfAllUnderlyingBinderLetters = '5005f632-35c1-40ea-924e-cf36a19cbdbe',
  // #14 - Copy of the primary carrier's applications
  CopyOfThePrimaryCarriersApplications = '428d29f0-bbac-43e2-87aa-4ef2a119917b',
  // #15 - Copy of underlying carrier's subjectivities
  CopyOfUnderlyingCarriersSubjectivities = '5e0380d8-7926-4300-b7ea-c0d59429c362',
  // #16 - Surplus Lines Affidavit - completed, signed and dated
  SurplusLinesAffidavitCompletedSignedAndDated = '1656ea51-2782-4e1c-a7dc-a56b1c74cac7',
  // #17 - Does the Applicant employ a data loss prevention solution?
  DoesTheApplicantEmployADataLossPreventionSolution = '410b56c8-2fbd-48e2-a5a1-3f8254f4d669',
  // #18 - Is sensitive data segregated in an isolated environment?
  IsSensitiveDataSegregatedInAnIsolatedEnvironment = 'cb164130-1bd9-4cb8-b8a3-011cc57eba2c',
  // #19 - What is your PCI Merchant Level?
  WhatIsYourPciMerchantLevel = '18ea9377-3242-49ed-8187-2ad31b79c9fe',
  // #20 - Are you currently compliant with PCI DSS?
  AreYouCurrentlyCompliantWithPciDss = 'bf0d3db9-573c-4902-95c1-e27e0b218b6c',
  // #21 - Does the Applicant require multi-factor authentication?
  DoesTheApplicantRequireMultiFactorAuthentication = '0be9c1c5-04c9-4718-bd08-2fc3e3729369',
  // #22 - Does the Applicant currently implement endpoint encryption that covers 100% of endpoints (e.g. laptops and desktops)?
  DoesTheApplicantCurrentlyImplementEndpointEncryptionThatCovers100OfEndpointsEGLaptopsAndDesktops = '3192ed0e-acbc-4aa0-b482-b056471f2c54',
  DoesTheApplicantCurrentlyImplementEndpointEncryptionThatCovers100OfEndpointsEGLa = DoesTheApplicantCurrentlyImplementEndpointEncryptionThatCovers100OfEndpointsEGLaptopsAndDesktops,
  // #23 - Does the Applicant conduct regular backup of business-critical systems and data?
  DoesTheApplicantConductRegularBackupOfBusinessCriticalSystemsAndData = '3cde6e55-c8b7-47d0-8177-091876725da9',
  // #24 - Does the Applicant have an email filtering solution in place to pre-screen emails for potentially malicious attachments and links?
  DoesTheApplicantHaveAnEmailFilteringSolutionInPlaceToPreScreenEmailsForPotentiallyMaliciousAttachmentsAndLinks = 'a55eacfb-bcc3-4dce-825b-7d681dc7dcc3',
  DoesTheApplicantHaveAnEmailFilteringSolutionInPlaceToPreScreenEmailsForPotential = DoesTheApplicantHaveAnEmailFilteringSolutionInPlaceToPreScreenEmailsForPotentiallyMaliciousAttachmentsAndLinks,
  // #25 - Does the Applicant use a next-generation antivirus product to detect and prevent known and unknown threats?
  DoesTheApplicantUseANextGenerationAntivirusProductToDetectAndPreventKnownAndUnknownThreats = '38bdb87c-089c-41d1-8f0d-8e6bc99d7f4a',
  DoesTheApplicantUseANextGenerationAntivirusProductToDetectAndPreventKnownAndUnkn = DoesTheApplicantUseANextGenerationAntivirusProductToDetectAndPreventKnownAndUnknownThreats,
  // #26 - Does the Applicant require all employees and independent contractors to undergo annual cybersecurity training?
  DoesTheApplicantRequireAllEmployeesAndIndependentContractorsToUndergoAnnualCybersecurityTraining = 'bdbbc74b-3807-4d08-abef-ece99cbb6aa0',
  DoesTheApplicantRequireAllEmployeesAndIndependentContractorsToUndergoAnnualCyber = DoesTheApplicantRequireAllEmployeesAndIndependentContractorsToUndergoAnnualCybersecurityTraining,
  // #27 - Does the Applicant require a secondary means of communication to validate the authenticity of funds transfer request before processing the request?
  DoesTheApplicantRequireASecondaryMeansOfCommunicationToValidateTheAuthenticityOfFundsTransferRequestBeforeProcessingTheRequest = '0d4eb332-f94b-4c09-8f8c-aa9edacfcb86',
  DoesTheApplicantRequireASecondaryMeansOfCommunicationToValidateTheAuthenticityOf = DoesTheApplicantRequireASecondaryMeansOfCommunicationToValidateTheAuthenticityOfFundsTransferRequestBeforeProcessingTheRequest,
  // #28 - TRIA Acceptance / Rejection letter
  TriaAcceptanceRejectionLetter = 'e4d1ae35-cda3-4b80-b28c-a6d774daeb84',
  // #29 - What is your total record count?
  WhatIsYourTotalRecordCount = '70d10268-d8f4-46cc-adef-16411cc45934',
  // #30 - Of your total record count, how many are in the follow categories: PII, PHI, PCI, Biometric?
  OfYourTotalRecordCountHowManyAreInTheFollowCategoriesPiiPhiPciBiometric = 'dc2ca3d4-f125-4998-be94-f6add380f70c',
  EndpointProtectionPlatformOrNextGenerationAntiVirus = '93f343f1-c093-4dce-a6e0-0e8f41494d6f',
  EndpointDetectionAndResponse = 'd5396311-4aab-4593-ae20-b4b693e4fbc4',
  MfaOnAllAccessToEmail = '1b36eaf5-7b26-4786-8bdb-4756e6fddacf',
  MfaOnAllRemoteAccess = '1b419e8e-63a4-4a63-8383-260c1f147e88',
  MfaOnCloudAccess = '674f02f2-748d-4edd-a24a-6b4fd2b551f4',
  AssetManagementSystem = '436a9cd9-f38f-4423-abe1-ca05037d4fed',
  LogsAnalyzedByEventManagementSystem = '63f2a613-6196-4f9e-888c-03552fd30b0e',
  NoLegacySoftware = 'd3e3a669-308a-4845-a638-74ea33ab1946',
  DataBackupAndRestoration = '36542fc9-629c-4a6a-a350-d49820ef740d',
  BackupsAccessControl = 'd0077b7d-573a-4a7e-a490-40ecb095494b',
  FavorableContractualControls = '4befdb3c-40e2-454d-8cec-b0946cdaa013',
  QualityControlProcedures = '7f833e0a-045d-4449-ac0d-a0037590531f',
  CriticalDataBackedUp = 'e0260680-6d20-4946-8b4f-cac377a7e8bc',
}

export const threeRowSubjectivities = [
  SubjectivityUuid.DoesTheApplicantRequireASecondaryMeansOfCommunicationToValidateTheAuthenticityOfFundsTransferRequestBeforeProcessingTheRequest,
];
export const twoRowSubjectivities = [
  SubjectivityUuid.DoesTheApplicantConductRegularBackupOfBusinessCriticalSystemsAndData,
  SubjectivityUuid.EndpointProtectionPlatformOrNextGenerationAntiVirus,
  SubjectivityUuid.EndpointDetectionAndResponse,
  SubjectivityUuid.MfaOnAllAccessToEmail,
  SubjectivityUuid.MfaOnAllRemoteAccess,
  SubjectivityUuid.MfaOnCloudAccess,
  SubjectivityUuid.AssetManagementSystem,
  SubjectivityUuid.NoLegacySoftware,
  SubjectivityUuid.DataBackupAndRestoration,
  SubjectivityUuid.BackupsAccessControl,
  SubjectivityUuid.FavorableContractualControls,
  SubjectivityUuid.QualityControlProcedures,
  SubjectivityUuid.LogsAnalyzedByEventManagementSystem,
  SubjectivityUuid.QualityControlProcedures,
  SubjectivityUuid.CriticalDataBackedUp,
];
export const CONVERGE_LINE_ITEMS = {
  coverages: {
    edges: [
      {
        node: {
          name: 'Network Security & Privacy Liability',
          order: 1,
          uuid: '4ecb1358-f82f-4f1e-890c-f7bc8f14f739',
          type: 'liability',
          subCoverages: {
            edges: [],
            pageInfo: {
              hasNextPage: false,
              totalResults: 0,
            },
          },
        },
      },
      {
        node: {
          name: 'Regulatory Proceedings',
          order: 2,
          uuid: '0478ce64-8a5e-487b-ac0c-493290750fbb',
          type: 'liability',
          subCoverages: {
            edges: [],
            pageInfo: {
              hasNextPage: false,
              totalResults: 0,
            },
          },
        },
      },
      {
        node: {
          name: 'PCI-DSS Events',
          order: 3,
          uuid: '529c1f9c-3aae-45c2-b95e-5e8366f830f8',
          type: 'liability',
          subCoverages: {
            edges: [],
            pageInfo: {
              hasNextPage: false,
              totalResults: 0,
            },
          },
        },
      },
      {
        node: {
          name: 'Incident Response',
          order: 4,
          uuid: '0831b749-acfb-497c-a8f2-0fa923bf2dc8',
          type: 'first_party',
          subCoverages: {
            edges: [
              {
                node: {
                  name: 'Post Incident Remediation',
                  order: 1,
                  uuid: '5c342728-fba9-458b-ac23-456e10849d35',
                },
              },
              {
                node: {
                  name: 'Pre Claim Mitigation',
                  order: 2,
                  uuid: '237a808a-a0e0-4095-8a5e-541ada7262b3',
                },
              },
            ],
            pageInfo: {
              hasNextPage: false,
              totalResults: 2,
            },
          },
        },
      },
      {
        node: {
          name: 'Cyber Extortion',
          order: 5,
          uuid: 'bd2afc71-6a4c-4e03-a977-bc6202ecdfbb',
          type: 'first_party',
          subCoverages: {
            edges: [
              {
                node: {
                  name: 'Criminal Reward',
                  order: 1,
                  uuid: '8f7b41a0-1d28-4c9a-921a-3e932f9ba5a5',
                },
              },
            ],
            pageInfo: {
              hasNextPage: false,
              totalResults: 1,
            },
          },
        },
      },
      {
        node: {
          name: 'Digital Asset Recovery',
          order: 6,
          uuid: '3c21dae0-2d6c-4e6d-829f-8b0ee6992a83',
          type: 'first_party',
          subCoverages: {
            edges: [],
            pageInfo: {
              hasNextPage: false,
              totalResults: 0,
            },
          },
        },
      },
      {
        node: {
          name: 'Bricked Equipment Replacement',
          order: 7,
          uuid: '3fb62f52-6d82-40d8-8b08-c95c62e71cdd',
          type: 'first_party',
          subCoverages: {
            edges: [],
            pageInfo: {
              hasNextPage: false,
              totalResults: 0,
            },
          },
        },
      },
      {
        node: {
          name: 'Cyber Crime',
          order: 8,
          uuid: '5e30a5d2-a741-479c-bf59-98e2f2618b2f',
          type: 'first_party',
          subCoverages: {
            edges: [
              {
                node: {
                  name: 'Social Engineering',
                  order: 1,
                  uuid: 'f86e2f2a-547f-4cd3-86fa-af5de2ddfbdd',
                },
              },
              {
                node: {
                  name: 'Telecom Fraud',
                  order: 2,
                  uuid: '01505a46-5136-4579-aed4-b73f1929bba2',
                },
              },
              {
                node: {
                  name: 'Invoice Manipulation',
                  order: 3,
                  uuid: '85d3bd90-2299-46a9-a1ad-4b04fdd44e6b',
                },
              },
              {
                node: {
                  name: 'Cryptojacking',
                  order: 4,
                  uuid: '540a7692-afb7-4b1e-bf0e-2d2e568dd680',
                },
              },
              {
                node: {
                  name: 'Computer Fraud',
                  order: 5,
                  uuid: '3afa23ac-233c-4b82-834d-43eb6f1966ca',
                },
              },
              {
                node: {
                  name: 'Funds Transfer Fraud',
                  order: 6,
                  uuid: '694211e3-a6a1-4e24-af5b-7c428b6129f5',
                },
              },
            ],
            pageInfo: {
              hasNextPage: false,
              totalResults: 6,
            },
          },
        },
      },
      {
        node: {
          name: 'Business Interruption',
          order: 9,
          uuid: '4be00fe4-45d5-4a53-b195-5d8c98b7a665',
          type: 'first_party_loss',
          subCoverages: {
            edges: [
              {
                node: {
                  name: 'Proof of Loss',
                  order: 1,
                  uuid: 'ae9e380b-946d-4514-a7f7-ae3e378f5d49',
                },
              },
            ],
            pageInfo: {
              hasNextPage: false,
              totalResults: 1,
            },
          },
        },
      },
      {
        node: {
          name: 'Contingent Business Interruption',
          order: 10,
          uuid: 'ec4d42c5-54bd-44e0-8d46-d170371ae636',
          type: 'first_party_loss',
          subCoverages: {
            edges: [
              {
                node: {
                  name: 'Proof of Loss',
                  order: 1,
                  uuid: 'ae9e380b-946d-4514-a7f7-ae3e378f5d49',
                },
              },
            ],
            pageInfo: {
              hasNextPage: false,
              totalResults: 1,
            },
          },
        },
      },
      {
        node: {
          name: 'Reputational Harm',
          order: 11,
          uuid: '148ccffd-5380-4f97-8b51-5463f21aa2b8',
          type: 'first_party_loss',
          subCoverages: {
            edges: [
              {
                node: {
                  name: 'Proof of Loss',
                  order: 1,
                  uuid: 'ae9e380b-946d-4514-a7f7-ae3e378f5d49',
                },
              },
            ],
            pageInfo: {
              hasNextPage: false,
              totalResults: 1,
            },
          },
        },
      },
    ],
    pageInfo: {
      hasNextPage: false,
      totalResults: 11,
    },
  },
  endorsements: {
    edges: [
      {
        node: {
          name: 'Additional Privacy Event Expenses – Outside the Limit',
          alias: 'Additional Privacy Event Expenses – Outside the Limit',
          nonPremiumBearing: true,
          order: 23,
          uuid: 'f04c31b5-2e41-4405-9574-6b6dad06194c',
          excess: false,
          primary: true,
          questions: {
            edges: [
              {
                node: {
                  uuid: '852f37b7-26d7-45f6-9607-a6880caf6386',
                  question: 'Additional Privacy Event Expenses',
                  type: 'LABEl',
                  order: 2012,
                },
              },
              {
                node: {
                  uuid: '7028829c-39d8-4b29-b706-ea7929d0620d',
                  question: 'Limit:',
                  type: 'CURRENCY',
                  order: 2013,
                },
              },
              {
                node: {
                  uuid: 'e46bc141-1272-4a19-92cb-b1e1f4239e16',
                  question: 'Retention:',
                  type: 'CURRENCY',
                  order: 2014,
                },
              },
            ],
          },
        },
      },

      {
        node: {
          name: 'Automatic Extended Reporting Amendatory',
          alias: 'Automatic Extended Reporting Amendatory',
          nonPremiumBearing: true,
          order: 1,
          uuid: '4af9b58a-4206-423c-8167-2d50b9c6cbb5',
          excess: false,
          primary: true,
          questions: {
            edges: [
              {
                node: {
                  uuid: '25767333-976c-4c05-913f-da45576dfbf8',
                  question: 'Enter days:',
                  type: 'FLOAT',
                  order: 2020,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'Cancellation Endorsement',
          alias: 'Cancellation Endorsement',
          nonPremiumBearing: true,
          order: 2,
          uuid: '9a7c39a6-09d4-4c59-bfa0-383bc39daa74',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          name: 'Cyber and Technology Errors and Omissions',
          alias: 'Cyber and Technology Errors and Omissions',
          nonPremiumBearing: false,
          order: 35,
          uuid: '3396e54c-e309-49a3-8549-23e4ad1986ca',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Artificial Intelligence Endorsement',
          alias: 'Artificial Intelligence Endorsement',
          nonPremiumBearing: false,
          order: 36,
          uuid: '5dab990e-88cb-4fd2-9f67-dec500b509a7',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Cancellation For Nonpayment of Premium Only',
          alias: 'Cancellation For Nonpayment of Premium Only',
          nonPremiumBearing: true,
          order: 3,
          uuid: '4d04e01f-35ca-41bd-a5f3-dbeae3b09a7b',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Cancellation and Nonrenewal Endorsement',
          alias: 'Cancellation and Nonrenewal Endorsement',
          nonPremiumBearing: true,
          order: 4,
          uuid: '51d3e608-d5f9-4e09-9522-81c19d2266c5',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Consent to Settle Endorsement',
          alias: 'Consent to Settle Endorsement',
          nonPremiumBearing: true,
          order: 5,
          uuid: '6067ea2c-14da-44ba-9bde-7f3204ebf656',
          excess: false,
          primary: true,
          questions: {
            edges: [
              {
                node: {
                  uuid: '122cf3d0-6cef-471c-bc37-93e2ddba4fc1',
                  question: "Converge's Percentage",
                  type: 'TEXT',
                  order: 2017,
                },
              },
              {
                node: {
                  uuid: 'a76fecd3-fc0b-4da4-8184-023b673d6a23',
                  question: "Insured's Percentage",
                  type: 'TEXT',
                  order: 2018,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'Contingent Bodily Injury and Property Damage Endorsement',
          alias: 'Contingent Bodily Injury and Property Damage Endorsement',
          nonPremiumBearing: true,
          order: 6,
          uuid: '5f6b574c-148c-433b-9824-f881fab2e532',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'RT Amendatory Endorsement',
          alias: 'RT Amendatory Endorsement',
          nonPremiumBearing: true,
          order: 30,
          uuid: 'b1249d0c-d67e-4979-963a-2d9220688d34',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Contingent Business Interruption - Non-IT Providers',
          alias: 'Contingent Business Interruption - Non-IT Providers',
          nonPremiumBearing: true,
          order: 7,
          uuid: 'a37ecf46-441a-462f-b299-df4d4e1a50ec',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Contingent Business Interruption for Non-IT Amendatory (Franchised Risk)',
          alias:
            'Contingent Business Interruption for Non-IT Amendatory (Franchised Risk)',
          nonPremiumBearing: true,
          order: 12,
          uuid: EndorsementUuid.ContingentBusinessInterruptionNonItFranchisedRisk,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Control Group Amendatory',
          alias: 'Control Group Amendatory',
          nonPremiumBearing: true,
          order: 8,
          uuid: '04e483ba-dd5c-4859-96d9-b60085e07c7b',
          excess: false,
          primary: true,
          questions: {
            edges: [
              {
                node: {
                  uuid: '7ec1ba3c-e4c2-4ea5-8c37-7c0859387cf7',
                  question: 'Enter new control group:',
                  type: 'multiline',
                  order: 2012,
                },
              },
              {
                node: {
                  uuid: '',
                  question:
                    'In consideration of the premium charged for this policy, it is hereby understood and agreed that in Section III, Definitions, Control Group is deleted in its entirety, and replaced with the following:',
                  type: 'LABEL',
                  order: 2011,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'Media Event Liability Endorsement',
          alias: 'Media Event Liability Endorsement',
          nonPremiumBearing: false,
          order: 9,
          uuid: '9041f69f-f216-4ffa-9f44-7488905eaae4',
          excess: false,
          primary: true,

          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Media Event Liability Endorsement – ONLINE / OFFLINE',
          alias: 'Media Event Liability Endorsement – ONLINE / OFFLINE',
          nonPremiumBearing: false,
          order: 20,
          uuid: 'f1ac94c5-1f03-47c7-b5ba-6c8c9f0a0bc8',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Newly Acquired Entity Endorsement',
          alias: 'Newly Acquired Entity Endorsement',
          nonPremiumBearing: true,
          order: 10,
          uuid: '7ee33742-8455-4872-b9b3-6b430d943463',
          excess: false,
          primary: true,

          questions: {
            edges: [],
          },
        },
      },
      // {
      //   node: {
      //     name: 'Notice of Terrorism Insurance Coverage',
      //     nonPremiumBearing: true,
      //     order: 11,
      //     uuid: '39225ef0-2f04-483c-87dc-89a69bdcb3fd',
      //     excess: true,
      //     primary: true,
      //     questions: {
      //       edges: [],
      //     },
      //   },
      // },

      {
        ///
        node: {
          name: 'BIPA Claims Expense Sublimit',
          alias: 'BIPA Claims Expense Sublimit',
          nonPremiumBearing: true,
          order: 11,
          uuid: '9e90d1ea-7a58-4920-ac35-985b3b74ba86',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'TCPA Claims Expense Sublimit of Insurance',
          alias: 'TCPA Claims Expense Sublimit of Insurance',
          nonPremiumBearing: true,
          order: 44,
          uuid: '47f0977c-4b7e-4dbd-a6da-de47a28bfb02',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Cryptojacking Limits Amendatory',
          alias: 'Cryptojacking Limits Amendatory',
          nonPremiumBearing: true,
          order: 46,
          uuid: '2be9cf00-8687-4476-838f-83734e397437',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Cyber Enhancement Endorsement ',
          alias: 'Cyber Enhancement Endorsement ',
          nonPremiumBearing: true,
          order: 47,
          uuid: '42a4b72b-9c37-4bc1-8b36-69fdac80fbef',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause',
          alias: 'Obsidian Excess Service of Suit Clause',
          nonPremiumBearing: true,
          order: 55,
          uuid: '7daa69f5-e78d-4cb8-ad41-c8e30bffe658',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause - Illinois for Excess',
          alias: 'Obsidian Excess Service of Suit Clause - Illinois for Excess',
          nonPremiumBearing: true,
          order: 57,
          uuid: 'c705b762-f5a5-4a48-9be0-7c16d943f5d9',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause',
          alias: 'Obsidian Excess Service of Suit Clause',
          nonPremiumBearing: true,
          order: 58,
          uuid: 'e8bfd009-1175-4785-9669-203b782022da',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause',
          alias: 'Obsidian Excess Service of Suit Clause',
          nonPremiumBearing: true,
          order: 59,
          uuid: 'b31fa47f-ac8e-4beb-9ef8-bd926f453ef8',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause - Florida',
          alias: 'Obsidian Excess Service of Suit Clause - Florida',
          nonPremiumBearing: true,
          order: 60,
          uuid: '86df5be2-e6e1-4ac3-a92d-48a2fb5bd3b9',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Service of Suit Clause - Florida',
          alias: 'Obsidian Service of Suit Clause - Florida',
          nonPremiumBearing: true,
          order: 61,
          uuid: 'd3b9d8e5-71cb-4dd2-8899-68228cebd114',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause -  Kentucky',
          alias: 'Obsidian Excess Service of Suit Clause -  Kentucky',
          nonPremiumBearing: true,
          order: 62,
          uuid: 'eb429cc2-de65-487f-9bec-5a94ea3d169d',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Service of Suit Clause -  Kentucky',
          alias: 'Obsidian Service of Suit Clause -  Kentucky',
          nonPremiumBearing: true,
          order: 63,
          uuid: '1a0f657e-623c-405a-ad82-1a0cebf70e68',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause -  Louisiana',
          alias: 'Obsidian Excess Service of Suit Clause -  Louisiana',
          nonPremiumBearing: true,
          order: 64,
          uuid: '8846c260-557e-4005-946a-bc930682903d',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Service of Suit Clause -  Louisiana',
          alias: 'Obsidian Service of Suit Clause -  Louisiana',
          nonPremiumBearing: true,
          order: 65,
          uuid: '07a8b2d1-f1ba-4f9d-b4fe-589cec2c72aa',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Service of Suit Clause -  Texas',
          alias: 'Obsidian Service of Suit Clause -  Texas',
          nonPremiumBearing: true,
          order: 66,
          uuid: '2346560b-faa1-4f64-b3b4-836017077198',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause -  Texas',
          alias: 'Obsidian Excess Service of Suit Clause -  Texas',
          nonPremiumBearing: true,
          order: 67,
          uuid: 'f7e031dc-15a9-4027-a746-e38072983a30',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian Excess Service of Suit Clause -  Virginia',
          alias: 'Obsidian Excess Service of Suit Clause -  Virginia',
          nonPremiumBearing: true,
          order: 68,
          uuid: 'a3260860-0346-4e36-875d-522ee1e45bd7',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Obsidian  Service of Suit Clause -  Virginia',
          alias: 'Obsidian  Service of Suit Clause -  Virginia',
          nonPremiumBearing: true,
          order: 69,
          uuid: '9a7a0136-4823-4114-93e0-2d75747f3cdd',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Obsidian Excess Service of Suit Clause - Vermont ',
          name: 'Obsidian Excess Service of Suit Clause - Vermont ',
          nonPremiumBearing: true,
          order: 70,
          uuid: 'e8435876-33e3-4dad-afe0-2a43c4f548be',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Obsidian Service of Suit Clause -  Vermont',
          name: 'Obsidian Service of Suit Clause -  Vermont',
          nonPremiumBearing: true,
          order: 71,
          uuid: '14d31f01-67df-47ff-9951-c2980e0fedce',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'TRIA Cap On Losses From Certified Acts of Terrorism',
          name: 'TRIA Cap On Losses From Certified Acts of Terrorism',
          nonPremiumBearing: true,
          order: 72,
          uuid: 'a14d9a09-f057-4776-8b9f-c09c91603ba1',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'TRIA Excess Cap On Losses From Certified Acts of Terrorism',
          name: 'TRIA Excess Cap On Losses From Certified Acts of Terrorism',
          nonPremiumBearing: true,
          order: 73,
          uuid: 'b88310e5-939b-490d-b857-fe6a7c4eb383',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Cyber Crime Event Definition Amendatory - Specified Property',
          name: 'Cyber Crime Event Definition Amendatory - Specified Property',
          nonPremiumBearing: true,
          order: 74,
          uuid: 'ee9456c2-96f5-48b5-abf1-4b9160931bc9',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'RT Amendatory Endorsement - Technology Errors & Omissions',
          name: 'RT Amendatory Endorsement - Technology Errors & Omissions',
          nonPremiumBearing: true,
          order: 75,
          uuid: '966894f9-e4de-48e6-b9a0-dd18244367bb',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Amwins Cyber Enhancement Endorsement',
          name: 'Amwins Cyber Enhancement Endorsement',
          nonPremiumBearing: true,
          order: 76,
          uuid: '5e453350-c2d3-48ba-a739-dd2035dd8bfc',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Bridge Specialty Cyber Enhancement Endorsement',
          name: 'Bridge Specialty Cyber Enhancement Endorsement',
          nonPremiumBearing: true,
          order: 77,
          uuid: 'c46e502f-34c2-48c6-9664-63677930bab4',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Other Insurance Amendatory Where Required by Contract',
          name: 'Other Insurance Amendatory Where Required by Contract',
          nonPremiumBearing: true,
          order: 78,
          uuid: EndorsementUuid.OtherInsuranceAmendatory1058,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Ransomware Event Sublimit',
          name: 'Ransomware Event Sublimit',
          nonPremiumBearing: true,
          order: 79,
          uuid: EndorsementUuid.RansomwareEventSublimit,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Cyber Extortion Amendatory',
          name: 'Cyber Extortion Amendatory',
          nonPremiumBearing: true,
          order: 80,
          uuid: EndorsementUuid.CyberExtortionAmendatory,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Pre-Approved Authorized Provider',
          name: 'Pre-Approved Authorized Provider',
          nonPremiumBearing: true,
          order: 81,
          uuid: EndorsementUuid.PreApprovedAuthorizedProvider,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Cancellation Endorsement',
          alias: 'Cancellation Endorsement',
          nonPremiumBearing: true,
          order: 82,
          uuid: '8164e660-4b96-4f3a-890f-3c29dc545850',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Tracking Technology Liability Coverage Endorsement',
          alias: 'Tracking Technology Liability Coverage Endorsement',
          nonPremiumBearing: false,
          order: 83,
          uuid: 'b757e37b-3e96-48fe-b7fc-83874cca64e7',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Other Insurance Amendatory',
          name: 'Other Insurance Amendatory',
          nonPremiumBearing: true,
          order: 8,
          uuid: EndorsementUuid.OtherInsuranceAmendatory1053,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias:
            'Obsidian Excess Service of Suit Clause - Washington for Excess',
          name: 'Obsidian Excess Service of Suit Clause - Washington for Excess',
          nonPremiumBearing: true,
          order: 56,
          uuid: 'c16a40b2-2823-48bd-aac9-096be5351f49',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'ADA Claims Expense Sublimit',
          name: 'ADA Claims Expense Sublimit',
          nonPremiumBearing: true,
          order: 45,
          uuid: '88738e9e-af74-4e71-9cc4-27abf62c8cba',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Cryptojacking Limits Amendatory',
          name: 'Cryptojacking Limits Amendatory',
          nonPremiumBearing: true,
          order: 46,
          uuid: '2be9cf00-8687-4476-838f-83734e397437',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Limit Amendatory Endorsement',
          name: 'Limit Amendatory Endorsement',
          nonPremiumBearing: true,
          order: 48,
          uuid: '2f08ad7d-bccf-4b98-8c63-57c48af1c156',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Service of Suit Clause - Washington',
          name: 'Service of Suit Clause - Washington',
          nonPremiumBearing: true,
          order: 49,
          uuid: 'aae47e45-aaa3-4872-b7c7-4448d128791d',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Service of Suit Clause',
          name: 'Service of Suit Clause',
          nonPremiumBearing: true,
          order: 50,
          uuid: 'c2988172-a02f-43e3-9495-238ad0dc1523',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Service of Suit Clause - Illinois',
          name: 'Service of Suit Clause - Illinois',
          nonPremiumBearing: true,
          order: 51,
          uuid: 'efb3590e-2beb-4e2f-b1eb-a947ef2260d3',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Operational Technology - Bricked Equipment',
          name: 'Operational Technology - Bricked Equipment',
          nonPremiumBearing: false,
          order: 12,
          uuid: '7db773c0-8813-4261-bae2-77e97e397ffb',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Operational Technology - Digital Assets',
          name: 'Operational Technology - Digital Assets',
          nonPremiumBearing: false,
          order: 13,
          uuid: '1f58b178-ee59-4825-b211-d74a5d1676e1',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Policy Reinstatement Endorsement',
          alias: 'Policy Reinstatement Endorsement',
          nonPremiumBearing: true,
          order: 14,
          uuid: 'f26a4104-d182-4f1e-b565-f27f5afb5368',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Retroactive Date Amendatory',
          name: 'Retroactive Date Amendatory',
          nonPremiumBearing: true,
          order: 15,
          uuid: 'd3740e31-2510-40c4-8037-d6e7d657afa8',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Schedule of Additional Insured',
          name: 'Schedule of Additional Insured',
          nonPremiumBearing: true,
          order: 16,
          uuid: 'e9b44603-fcab-4a80-8748-45749d55d0a2',
          excess: false,
          primary: true,
          questions: {
            edges: [
              {
                node: {
                  uuid: 'b5661d68-415b-4344-9c9c-307509ec2db6',
                  question: 'Enter additional insured:',
                  type: 'MULTILINE',
                  order: 2010,
                },
              },
              {
                node: {
                  uuid: '6a82fe07-03ae-4bc0-b0f3-ed87a0ed590a',
                  question:
                    'In consideration of the premium charged, it is hereby agreed that the definition of Additional Insured is amended to include the following, but only as respects to vicarious liability of the Insured Entity',
                  type: 'LABEL',
                  order: 2009,
                },
              },
            ],
          },
        },
      },

      {
        node: {
          name: 'Schedule of Named Insured',
          alias: 'Schedule of Named Insured',
          nonPremiumBearing: true,
          order: 17,
          uuid: '0df24881-d3b0-4a47-aba3-9e917f34c74c',
          excess: false,
          primary: true,
          questions: {
            edges: [
              {
                node: {
                  uuid: '9b4b77bd-a286-44ee-b52f-1bb487ac38b2',
                  question: 'Named Insured:',
                  type: 'MULTILINE',
                  order: 2014,
                },
              },
              {
                node: {
                  uuid: '6a82fe07-03ae-4bc0-b0f3-ed87a0ed590a',
                  question:
                    'In consideration of the premium charged it is hereby agreed that the following is added to the definition of Named Insured',
                  type: 'LABEL',
                  order: 2013,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'Service of Process',
          alias: 'Service of Process',
          nonPremiumBearing: true,
          order: 18,
          uuid: 'daf4bf8a-6b2c-49c2-9685-365e2e7f03ba',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'State Fraud Statement',
          alias: 'State Fraud Statement',
          nonPremiumBearing: true,
          order: 19,
          uuid: '35f2894d-afc1-48b1-a0b5-8c894c1c9e10',
          excess: true,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Technology Errors and Omissions Endorsement',
          alias: 'Technology Errors and Omissions Endorsement',
          nonPremiumBearing: false,
          order: 20,
          uuid: 'c47d87bd-e452-4a58-bd4a-87fdf6397f48',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Quota Share Endorsement',
          alias: 'Quota Share Endorsement',
          nonPremiumBearing: false,
          order: 32,
          uuid: 'c14927ed-14d1-4516-8cf4-bb26a8fd44a0',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Quota Share Excess Endorsement',
          alias: 'Quota Share Excess Endorsement',
          nonPremiumBearing: false,
          order: 31,
          uuid: '5d8f4b2e-176e-4b4d-8a3b-c580f33b517d',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        //
        node: {
          name: 'Waiver of Change in Control Endorsement',
          alias: 'Waiver of Change in Control Endorsement',
          nonPremiumBearing: true,
          order: 21,
          uuid: 'c876b210-a9d9-4f57-8e39-1c8b4dac909d',
          excess: false,
          primary: true,
          questions: {
            edges: [
              {
                node: {
                  uuid: 'f85c6d3b-e6ec-4cdd-b887-8eb674f2719f',
                  question: 'Legal name of acquiring entity',
                  type: 'TEXT',
                  order: 2015,
                },
              },
              {
                node: {
                  uuid: 'a3800d8f-e212-42fe-a2bd-92de3068cab5',
                  question: 'Date of acquisition',
                  type: 'DATE',
                  order: 2016,
                },
              },
            ],
          },
        },
      },

      {
        node: {
          name: 'Wrongful Collection Exclusion Endorsement',
          alias: 'Wrongful Collection Exclusion Endorsement',
          nonPremiumBearing: true,
          order: 22,
          uuid: '280b0546-585b-4cf4-9a95-031543195d69',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          name: 'Wrongful Collection Exclusion Pixel Endorsement',
          alias: 'Wrongful Collection Exclusion Pixel Endorsement',
          nonPremiumBearing: true,
          order: 23,
          uuid: EndorsementUuid.WrongfulCollectionExclusionPixelEndorsement,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          name: 'Lockton Affinity Amendatory Endorsement',
          alias: 'Lockton Affinity Amendatory Endorsement',
          nonPremiumBearing: true,
          order: 23,
          uuid: '654b788f-e126-4ebd-bb5f-baa9167da513',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Cyber Crime Loss Definition Amendatory ',
          alias: 'Cyber Crime Loss Definition Amendatory ',
          nonPremiumBearing: true,
          order: 24,
          uuid: '37ee1b21-8cf3-407d-ba63-01590bd0eea2',
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      // {
      //   node: {
      //     name: 'Policyholder Notice',
      //     nonPremiumBearing: true,
      //     order: 100,
      //     uuid: 'a381fe95-f69f-4d7e-bdca-e6594a41e4d6',
      //     excess: true,
      //     primary: true,
      //     questions: {
      //       edges: [],
      //     },
      //   },
      // },
      {
        node: {
          name: 'Follow Form of Underlying Provisions Endorsement (Follow Specified Insuring Agreements – Recognize Erosion)',
          alias:
            'Follow Form of Underlying Provisions Endorsement (Follow Specified Insuring Agreements – Recognize Erosion)',
          nonPremiumBearing: true,
          order: 101,
          uuid: '308b01e8-04e2-4118-a555-acd92c06ee9a',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Follow Form of Underlying Provisions Endorsement (Follow Specified Insuring Agreements – Not Recognize Erosion)',
          alias:
            'Follow Form of Underlying Provisions Endorsement (Follow Specified Insuring Agreements – Not Recognize Erosion)',
          nonPremiumBearing: true,
          order: 102,
          uuid: '91281677-8f5d-47a3-b154-0573f6795db8',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Infrastructure Exclusion',
          alias: 'Infrastructure Exclusion',
          nonPremiumBearing: true,
          order: 103,
          uuid: EndorsementUuid.InfrastructureExclusionForExcess,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Natural Perils Exclusion',
          alias: 'Natural Perils Exclusion',
          nonPremiumBearing: true,
          order: 104,
          uuid: '738305cf-ee8c-4ea8-880a-424ce8101e1b',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Not Following Underlying Insurance (Not Recognize Erosion)',
          alias: 'Not Following Underlying Insurance (Not Recognize Erosion)',
          nonPremiumBearing: true,
          order: 105,
          uuid: 'c0e7aa5c-a57f-4cd8-bf7b-181ef2194c6d',
          excess: true,
          primary: false,
          questions: {
            edges: [
              {
                node: {
                  uuid: 'cc73d162-63cc-4d12-b373-3627d043a8e4',
                  question:
                    'In consideration of the premium charged for this policy, it is hereby understood and agreed that this policy shall not apply in conformance with, or follow form to, the terms and conditions of the Underlying Insurance as described in the schedule below.',
                  type: 'MULTILINE',
                  order: 2007,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'Not Following Underlying Insurance (but Recognize Erosion)',
          alias: 'Not Following Underlying Insurance (but Recognize Erosion)',
          nonPremiumBearing: true,
          order: 106,
          uuid: 'cc872ae9-cb43-4115-8d82-2dde85915dee',
          excess: true,
          primary: false,
          questions: {
            edges: [
              {
                node: {
                  uuid: '79537328-453b-4e67-9129-18aaf28a6dc3',
                  question:
                    'In consideration of the premium charged for this policy, it is hereby understood and agreed that this policy shall not apply in conformance with, or follow form to, the terms and conditions of the Underlying Insurance as described in the schedule below.',
                  type: 'MULTILINE',
                  order: 2008,
                },
              },
            ],
          },
        },
      },
      // {
      //   node: {
      //     name: 'U.S. Treasury Department’s Office of Foreign Assets Control (OFAC)',
      //     nonPremiumBearing: true,
      //     order: 107,
      //     uuid: '29eaefab-f6c1-4fad-a5f9-43ead1b383b2',
      //     excess: true,
      //     primary: false,
      //     questions: {
      //       edges: [],
      //     },
      //   },
      // },
      {
        node: {
          name: 'Pending and Prior Litigation Exclusion for Higher Limits',
          alias: 'Pending and Prior Litigation Exclusion for Higher Limits',
          nonPremiumBearing: true,
          order: 108,
          uuid: '48fab8ea-9d8b-4732-868c-17ccb89e5a7c',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Pending and Prior Litigation Exclusion',
          alias: 'Pending and Prior Litigation Exclusion',
          nonPremiumBearing: true,
          order: 109,
          uuid: 'dea6b467-5e04-4037-91cc-9489c1f1e287',
          excess: true,
          primary: false,
          questions: {
            edges: [
              {
                node: {
                  uuid: 'b11aff4e-b65b-43bf-bbda-c2d05c81c3c2',
                  question: 'Pending and Prior Date:',
                  type: 'DATE',
                  order: 2001,
                },
              },
              {
                node: {
                  uuid: '6a2d1394-0493-44da-a3de-08a09b29346b',
                  question:
                    'In consideration of the premium charged for this policy, it is hereby understood and agreed that coverage under this policy shall not apply to any claim based upon, arising out of, or attributable to any pending and prior litigation, demand, administrative or regulatory proceeding, or investigation, or alternative dispute proceeding that was pending, or order, decree or judgment entered on or prior to the following pending and prior date.',
                  type: 'LABEL',
                  order: 2000,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'Prior Knowledge Exclusion',
          alias: 'Prior Knowledge Exclusion',
          nonPremiumBearing: true,
          order: 110,
          uuid: '738ae565-ca45-48ca-a036-77acbaacd91f',
          excess: true,
          primary: false,
          questions: {
            edges: [
              {
                node: {
                  uuid: '38edb001-7815-4075-8f29-5c64a6420bca',
                  question: 'Prior Knowledge Exclusion Date:',
                  type: 'DATE',
                  order: 2003,
                },
              },
              {
                node: {
                  uuid: 'a4328421-9213-4305-ad25-430c2b91206a',
                  question:
                    'In consideration of the premium charged for this policy, it is hereby understood and agreed that this policy shall not apply to any claim based upon, arising out of, or attributable to any incident, event, act, error, omission, fact, or circumstance that any Insured had knowledge of before (insert date) and that could reasonably give rise to a claim.',
                  type: 'LABEL',
                  order: 2002,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'Retroactive Date Endorsement',
          alias: 'Retroactive Date Endorsement',
          nonPremiumBearing: true,
          order: 111,
          uuid: 'eef49489-ec20-4ff7-9b88-147b626b1c95',
          excess: true,
          primary: false,
          questions: {
            edges: [
              {
                node: {
                  uuid: 'e6706128-6eca-4910-8047-a56459fb4caf',
                  question: 'Retroactive Date:',
                  type: 'DATE',
                  order: 2005,
                },
              },
              {
                node: {
                  uuid: 'cea8eba0-8711-4fec-a8b2-ca8c79d04948',
                  question:
                    'In consideration of the premium charged for this policy, it is hereby understood and agreed that the Insurer shall not be liable under this policy for any loss on account of a claim alleging, based upon, arising out of, or attributable to any event, act, error, omission, misstatement, misleading statement, misrepresentation, breach of duty, incident, or wrongful act committed or allegedly committed prior to (insert retroactive date).',
                  type: 'LABEL',
                  order: 2004,
                },
              },
            ],
          },
        },
      },

      {
        node: {
          name: 'Retroactive Date Amendatory for Increased Limits',
          alias: 'Retroactive Date Amendatory for Increased Limits',
          nonPremiumBearing: true,
          order: 112,
          uuid: 'b592e4fe-ec17-4600-8565-7a278bb4d346',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Sublimited Coverage Endorsement',
          alias: 'Sublimited Coverage Endorsement',
          nonPremiumBearing: true,
          order: 113,
          uuid: EndorsementUuid.SublimitedCoverageEndorsementForExcess,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'War Exclusion',
          alias: 'War Exclusion',
          nonPremiumBearing: true,
          order: 114,
          uuid: '6e0cb132-e118-43a2-b12a-b812bbcb8813',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'War Exclusion with Cyberterrorism Carveback',
          alias: 'War Exclusion with Cyberterrorism Carveback',
          nonPremiumBearing: true,
          order: 115,
          uuid: 'a5df5c5b-51a1-430f-8bee-d5e7492a844f',
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          name: 'Declarations Amendatory Endorsement',
          alias: 'Declarations Amendatory Endorsement',
          nonPremiumBearing: true,
          order: 116,
          uuid: '59a46941-6d2e-47e0-806c-54881bd4ba2d',
          excess: true,
          primary: false,
          questions: {
            edges: [
              {
                node: {
                  uuid: 'e263209c-9019-4179-991a-6adbf5001d32',
                  question:
                    'In consideration of the premium charged for this policy it is agreed that the following change(s) is made to the policy Declarations:',
                  type: 'MULTILINE',
                  order: 2006,
                },
              },
            ],
          },
        },
      },
      {
        node: {
          name: 'TRACKING TECHNOLOGY CLAIMS EXPENSE SUBLIMIT OF INSURANCE',
          alias: 'TRACKING TECHNOLOGY CLAIMS EXPENSE SUBLIMIT OF INSURANCE',
          nonPremiumBearing: false,
          order: 117,
          uuid: EndorsementUuid.TrackingTechnologyClaimsExpenseSublimit,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Cyber Event Amendatory',
          name: 'Cyber Event Amendatory',
          nonPremiumBearing: false,
          order: 118,
          uuid: EndorsementUuid.CyberEventAmendatory,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Missed Bid Amendatory',
          name: 'Missed Bid Amendatory',
          nonPremiumBearing: false,
          order: 119,
          uuid: EndorsementUuid.MissedBidAmendatory,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Burns And Wilcox Cyber Enhancement Amendatory',
          name: 'Burns And Wilcox Cyber Enhancement Amendatory',
          nonPremiumBearing: false,
          order: 120,
          uuid: EndorsementUuid.BurnsAndWilcoxCyberEnhancementAmendatory,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'WAR EXCLUSION AMENDATORY',
          name: 'WAR EXCLUSION AMENDATORY',
          nonPremiumBearing: false,
          order: 124,
          uuid: EndorsementUuid.WarExclusionAmendatory,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Lioyds Service of Suit',
          name: 'Lioyds Service of Suit',
          nonPremiumBearing: false,
          order: 125,
          uuid: EndorsementUuid.LloydsAmericaServiceOfSuitClause,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },

      {
        node: {
          alias: 'Technology Errors And Omissions Endorsement (NA)',
          name: 'Technology Errors And Omissions Endorsement (NA)',
          nonPremiumBearing: false,
          order: 126,
          uuid: EndorsementUuid.TechnologyErrorsAndOmissionsEndorsementNA,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Specific Event Exclusion',
          name: 'Specific Event Exclusion',
          nonPremiumBearing: false,
          order: 127,
          uuid: EndorsementUuid.SpecificEventExclusion,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Specific Event Exclusion (Not Recognize Erosion)',
          name: 'Specific Event Exclusion (Not Recognize Erosion)',
          nonPremiumBearing: true,
          order: 127,
          uuid: EndorsementUuid.SpecificEventExclusionNotRecognizeErosion,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Specific Event Exclusion (Recognize Erosion)',
          name: 'Specific Event Exclusion (Recognize Erosion)',
          nonPremiumBearing: true,
          order: 127,
          uuid: EndorsementUuid.SpecificEventExclusionRecognizeErosion,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'CRC CYBER ENHANCEMENT ENDORSEMENT',
          name: 'CRC CYBER ENHANCEMENT ENDORSEMENT',
          nonPremiumBearing: false,
          order: 127,
          uuid: EndorsementUuid.CrcCyberEnhancement,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'RPS Cyber Enhancement Endorsement',
          name: 'RPS Cyber Enhancement Endorsement',
          nonPremiumBearing: false,
          order: 127,
          uuid: EndorsementUuid.RPSCyberEnhancement,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Avoca Risk Cyber Enhancement Endorsement',
          name: 'Avoca Risk Cyber Enhancement Endorsement',
          nonPremiumBearing: true,
          order: 127,
          uuid: EndorsementUuid.AvocaRiskCyberEnhancement,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Nuclear Energy Exclusion',
          name: 'Nuclear Energy Exclusion',
          nonPremiumBearing: true,
          order: 128,
          uuid: EndorsementUuid.NuclearEnergyExclusion,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Nuclear Energy Or Contamination',
          name: 'Nuclear Energy Or Contamination',
          nonPremiumBearing: true,
          order: 129,
          uuid: EndorsementUuid.NuclearEnergyOrContamination,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'War Exclusion Endorsement',
          name: 'War Exclusion Endorsement',
          nonPremiumBearing: true,
          order: 130,
          uuid: EndorsementUuid.WarExclusionForExcess,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias:
            'Terrorism Risk Insurance Act Rejection Confirmation Endorsemen',
          name: 'Terrorism Risk Insurance Act Rejection Confirmation Endorsemen',
          nonPremiumBearing: true,
          order: 131,
          uuid: EndorsementUuid.TerrorismRiskInsuranceActRejectionConfirmationEndorsement,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Trade Or Economic Sanctions Endorsement',
          name: 'Trade Or Economic Sanctions Endorsement',
          nonPremiumBearing: true,
          order: 132,
          uuid: EndorsementUuid.TradeOrEconomicSanctionsEndorsement,
          excess: true,
          primary: false,
          questions: {
            edges: [],
          },
        },
      },
      {
        node: {
          alias: 'Wholesure Amendatory Endorsement',
          name: 'Wholesure Amendatory Endorsement',
          nonPremiumBearing: true,
          order: 133,
          uuid: EndorsementUuid.WholeSureAmendatory,
          excess: false,
          primary: true,
          questions: {
            edges: [],
          },
        },
      },
    ],
    pageInfo: {
      hasNextPage: false,
      totalResults: 45,
    },
  },
  subjectivities: {
    edges: [
      {
        node: {
          name: 'Completed & currently signed and dated applications',
          order: 1,
          uuid: 'af8e2ca9-51d6-43fc-8545-77b082550de1',
        },
      },
      {
        node: {
          name: 'Completed & currently signed and dated supplemental applications',
          order: 2,
          uuid: '5e83345a-8169-4bb7-80fe-ae0db148729f',
        },
      },
      {
        node: {
          name: 'Completed, signed and dated Converge Application',
          order: 3,
          uuid: '4c465fd5-64ee-4be6-a7a8-fa9c7eb0956a',
        },
      },
      {
        node: {
          name: 'Loss Runs (3 to 5 years)',
          order: 4,
          uuid: '42365e60-4331-461e-a458-e86fd3210856',
        },
      },
      {
        node: {
          name: 'Details on all paid and/or open claims',
          order: 5,
          uuid: 'ccb305b3-97e4-4566-88ee-4d83f06cc780',
        },
      },
      {
        node: {
          name: 'Current Financial Information',
          order: 6,
          uuid: 'c7b34638-ad33-47d8-9bbb-f6fa81eff88b',
        },
      },
      {
        node: {
          name: 'Currently signed and dated warranty statement',
          order: 7,
          uuid: 'c72d2d77-4aa5-436e-9265-e6d6308b4afb',
        },
      },
      {
        node: {
          name: 'Currently signed and dated warranty statement for increased limits',
          order: 8,
          uuid: '54096ee4-9260-4dbd-880a-c421ce7eb664',
        },
      },
      {
        node: {
          name: 'Copy of the applicants organizational chart',
          order: 9,
          uuid: 'a765fa91-8d80-4dd7-a920-3b1deed2dd9c',
        },
      },
      {
        node: {
          name: 'Explanation of applications relationship with affiliate entities or sister companies',
          order: 10,
          uuid: '5dbef317-9842-4193-99ed-81ea4e27b83c',
        },
      },
      {
        node: {
          name: 'Copy of all underlying policies',
          order: 11,
          uuid: '522ba9cc-c71b-46f2-969c-7c1b90d04dc1',
        },
      },
      {
        node: {
          name: 'Copy of all underlying quote letters',
          order: 12,
          uuid: 'bfb4548b-59a4-43a4-b5a9-68fefca7940d',
        },
      },
      {
        node: {
          name: 'Copy of all underlying binder letters',
          order: 13,
          uuid: '5005f632-35c1-40ea-924e-cf36a19cbdbe',
        },
      },
      {
        node: {
          name: "Copy of the primary carrier's applications",
          order: 14,
          uuid: '428d29f0-bbac-43e2-87aa-4ef2a119917b',
        },
      },
      {
        node: {
          name: "Copy of underlying carrier's subjectivities",
          order: 15,
          uuid: '5e0380d8-7926-4300-b7ea-c0d59429c362',
        },
      },
      {
        node: {
          name: 'Surplus Lines Affidavit - completed, signed and dated',
          order: 16,
          uuid: '1656ea51-2782-4e1c-a7dc-a56b1c74cac7',
        },
      },
      {
        node: {
          name: 'Does the Applicant employ a data loss prevention solution?',
          order: 17,
          uuid: '410b56c8-2fbd-48e2-a5a1-3f8254f4d669',
        },
      },
      {
        node: {
          name: 'Is sensitive data segregated in an isolated environment?',
          order: 18,
          uuid: 'cb164130-1bd9-4cb8-b8a3-011cc57eba2c',
        },
      },
      {
        node: {
          name: 'What is your PCI Merchant Level? ',
          order: 19,
          uuid: '18ea9377-3242-49ed-8187-2ad31b79c9fe',
        },
      },
      {
        node: {
          name: 'Are you currently compliant with PCI DSS?',
          order: 20,
          uuid: 'bf0d3db9-573c-4902-95c1-e27e0b218b6c',
        },
      },
      {
        node: {
          name: 'Does the Applicant require multi-factor authentication?',
          order: 21,
          uuid: '0be9c1c5-04c9-4718-bd08-2fc3e3729369',
        },
      },
      {
        node: {
          name: 'Does the Applicant currently implement endpoint encryption that covers 100% of endpoints (e.g. laptops and desktops)? ',
          order: 22,
          uuid: '3192ed0e-acbc-4aa0-b482-b056471f2c54',
        },
      },
      {
        node: {
          name: 'Does the Applicant conduct regular backup of business-critical systems and data?',
          order: 23,
          uuid: '3cde6e55-c8b7-47d0-8177-091876725da9',
        },
      },
      {
        node: {
          name: 'Does the Applicant have an email filtering solution in place to pre-screen emails for potentially malicious attachments and links?',
          order: 24,
          uuid: 'a55eacfb-bcc3-4dce-825b-7d681dc7dcc3',
        },
      },
      {
        node: {
          name: 'Does the Applicant use a next-generation antivirus product to detect and prevent known and unknown threats?',
          order: 25,
          uuid: '38bdb87c-089c-41d1-8f0d-8e6bc99d7f4a',
        },
      },
      {
        node: {
          name: 'Does the Applicant require all employees and independent contractors to undergo annual cybersecurity training?',
          order: 26,
          uuid: 'bdbbc74b-3807-4d08-abef-ece99cbb6aa0',
        },
      },
      {
        node: {
          name: 'Does the Applicant require a secondary means of communication to validate the authenticity of funds transfer request before processing the request?',
          order: 27,
          uuid: '0d4eb332-f94b-4c09-8f8c-aa9edacfcb86',
        },
      },
      {
        node: {
          name: 'TRIA Acceptance / Rejection letter',
          order: 28,
          uuid: 'e4d1ae35-cda3-4b80-b28c-a6d774daeb84',
        },
      },
      {
        node: {
          name: 'What is your total record count?',
          order: 29,
          uuid: '70d10268-d8f4-46cc-adef-16411cc45934',
        },
      },
      {
        node: {
          name: 'Of your total record count, how many are in the follow categories: PII, PHI, PCI, Biometric?',
          order: 30,
          uuid: 'dc2ca3d4-f125-4998-be94-f6add380f70c',
        },
      },
    ],
    pageInfo: {
      hasNextPage: false,
      totalResults: 30,
    },
  },
};
